import React, { useState, useMemo } from "react";
import { ISearchParameters } from "./ISearchParameters";
import {
  Chat,
  ChatMessageSendEvent,
  ChatActionExecuteEvent,
  Message,
  ChatMessageBoxProps
} from "@progress/kendo-react-conversational-ui";
import { user, ActionWithFilter } from "./allMessages";

interface RecommenderChatProps {
  onSearchItem: (messageIndex: number, param: ActionWithFilter | any) => void;
  allMessages: Message[];
}

const MessageBox = (msgbxProps: ChatMessageBoxProps) => { return (<React.Fragment></React.Fragment>); }

const RecommenderChat = ({ onSearchItem, allMessages }: RecommenderChatProps) => {

  const initialMessage: Message = allMessages[0];

  const [messages, setMessages] = useState<Message[]>([initialMessage]);
  const [counter, setCounter] = useState(1);
  //const [filterParams, setFilterParams] = useState<ISearchParameters>({});

  const addNewMessage = (event: ChatMessageSendEvent) => {
    const previousIndex= counter-1;
    const previousMessage= allMessages[previousIndex];
    const answer = previousMessage.suggestedActions.find(x => x.value == event.message.text);
    //console.log(previousMessage, answer);
    onSearchItem(previousIndex, answer);

    setCounter(count => count + 1);
    //console.log(counter, event);


    // let botResponse = Object.assign({}, event.message);
    // botResponse.text = event.message.text;
    // botResponse.author = bot;
    const botResponse = allMessages[counter];
    setMessages((oldMessage) => [...oldMessage, event.message]);
    setTimeout(() => { setMessages((oldMessage) => [...oldMessage, botResponse]); }, 1000);
  };

  const onAction = (event: ChatActionExecuteEvent) => {
    if (event.action.type === "alert") {
      setMessages([...messages, { author: user, text: event.action.value }]);
    }
  };

  const messageBox = useMemo(() => (props: any) => <MessageBox {...props} />, []);

  return (
    <div>
      <Chat
        user={user}
        messages={messages}
        onMessageSend={addNewMessage}
        width={320}
        onActionExecute={onAction}
        messageBox={messageBox}
      />
    </div>
  );
};

export default RecommenderChat;
